
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --body-font-size:var(--fs-body-sm);
  flex:1;
}

:host([active]) .org-chart-panel--content{
    display:block;
  }

:host([active]) .enable-border-bottom{
    border-bottom:2px solid var(--brand-gray-400);
  }

.org-chart-panel{
  display:flex;
  flex-direction:column;
  width:100%;
}

.org-chart-panel-content{
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  padding:var(--spacing-4) 0;
}

.org-chart-panel--heading{
  display:flex;
  width:100%;
  justify-content:space-between;
  align-items:center;
  border-bottom:2px solid var(--brand-gray-400);
  cursor:pointer;
}

.org-chart-panel--heading:hover .org-chart-panel--button::after{
        outline-width:4px;
      }

.org-chart-panel--button{
  background-color:var(--brand-bright-blue-900);
  padding:var(--spacing-2);
  border:0px solid;
  width:var(--spacing-8);
  height:var(--spacing-8);
  transition:all 0.2s ease-in;
  outline-color:var(--brand-dark-blue-900);
  outline-style:solid;
  outline-offset:8px;
  outline-width:0px;
  position:relative;
  border-radius:0.25rem;
}

.org-chart-panel--button::after{
    content:'';
    position:absolute;
    top:0;
    left:0;
    height:100%;
    width:100%;
    border-radius:0.25rem;
    outline:solid 0px var(--brand-bright-blue-900);
  }

.org-chart-panel--button:hover::after{
      outline-width:4px;
    }

.org-chart-panel--button:focus{
    outline-width:4px;
  }

.org-chart-panel--button:focus::after{
      outline-width:4px;
    }

.org-chart-panel--header{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
}

.org-chart-panel--icon{
  color:var(--brand-dark-blue-900);
}

.org-chart-panel--content{
  display:none;
  padding-left:var(--spacing-4);
  background-color:var(--brand-gray-200);
}

.header-text,
.header-link{
  font-size:var(--fs-lg);
  color:var(--brand-dark-blue-900);
  font-weight:var(--fw-bold);
  font-family:var(--ff-display);
  line-height:var(--lh-percentage-sm);
  text-decoration:none;
}

.header-link:hover{
  text-decoration:underline;
}

.sub-header-text{
  color:var(--brand-gray-900);
  font-weight:var(--fw-normal);
  line-height:var(--lh-percentage-body);
}

.panel-content-icon{
  margin-right:var(--spacing-2);
}
`;